<template>
	<Card :title="trans('enrollments.summary.title')" :subtitle="trans('enrollments.summary.subtitle')">
		<div class="flex items-end gap-1">
			<p class="font-semibold">{{ event.title }}</p>
			<div class="grow border-b-2 border-b-gray-300 dark:border-b-slate-700 border-dotted mb-1"/>
			<div class="flex items-center whitespace-nowrap">$ {{ formatNumber(enrollment.price) }}</div>
		</div>
		<div v-for="pack in selectedPacks" class="flex flex-col gap-1">
			<div class="flex items-end gap-1">
				<p class="font-semibold">{{ pack.name }}</p>
				<div class="grow border-b-2 border-b-gray-300 dark:border-b-slate-700 border-dotted mb-1"/>
				<p class="whitespace-nowrap">$ {{ formatNumber(pack.pivot.price) }}</p>
			</div>
			<p v-for="enrollmentActivity in enrollmentActivities[pack.id]" class="ml-4 text-sm text-gray-600 dark:text-gray-400">{{ enrollmentActivity.activity.title }}</p>
		</div>
		<div v-for="offer in selectedOffers" class="flex flex-col gap-1">
			<div class="flex items-end gap-1">
				<p class="font-semibold">{{ offer.title }}</p>
				<div class="grow border-b-2 border-b-gray-300 dark:border-b-slate-700 border-dotted mb-1"/>
				<p class="whitespace-nowrap">$ {{ formatNumber(offer.pivot.price) }}</p>
			</div>
		</div>
		<hr>
		<div class="flex items-center gap-3 font-bold">
			<p class="grow">{{ trans('enrollments.invoice.total') }}</p>
			<p class="whitespace-nowrap">$ {{ formatNumber(enrollment.total_price) }}</p>
		</div>
	</Card>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {formatNumber} from '@/helpers'
import {defineProps, ref, type Ref} from 'vue'
import Card from '@/Components/Cards/Card.vue'
import {type Event} from '@/Types/Events/Event'
import {type Pack} from '@/Types/Events/Packs/Pack'
import {type Offer} from '@/Types/Events/Bundles/Offers/Offer'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import {type EnrollmentActivity} from '@/Types/Events/Enrollments/EnrollmentActivity'

const props = defineProps<{
	event:Event,
	enrollment:Enrollment,
	selectedPacks:Array<Pack>,
	selectedOffers:Array<Offer>,
	enrollmentActivities:Array<Array<EnrollmentActivity>>,
}>()

const event:Ref<Event> = ref(props.event)
const enrollment:Ref<Enrollment> = ref(props.enrollment)
const selectedPacks:Ref<Array<Pack>> = ref(props.selectedPacks)
const selectedOffers:Ref<Array<Offer>> = ref(props.selectedOffers)
const enrollmentActivities:Ref<Array<Array<EnrollmentActivity>>> = ref(props.enrollmentActivities)
</script>